// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-subway[data-v-868d128e]{display:flex;flex-direction:column;justify-content:space-between;min-height:50vh;padding:25px 3px 0 25px}.buttons-wrapper[data-v-868d128e]{background-color:#fff;bottom:0;padding:10px 35px 10px 10px;position:sticky;z-index:2}.buttons-wrapper button[data-v-868d128e]{font-weight:700}.loader-wrapper[data-v-868d128e]{align-items:center;display:flex;justify-content:center;min-height:70vh;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
